import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ValidationContext from "../../providers/ValidationContext";
import { validateField } from "../../validation/formValidation";
import ProductTreeSelector from "./ProductTreeSelector";

require("./ProductGroupSelector.css");

interface Props {
    selectedProductGroupName: string;
    selectedProductGroupId: number;
    productId: number;
    label?: string;
    id?: string;
    productGroups: any[];
    onGroupSelectionChange: any;
    isRequired?: boolean;
    isValid?: boolean;
    dataField?: string;
}

const ProductGroupSelector = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'ProductGroupsTree' })
    const dispatch = useDispatch();
    const [selectionOpened, setSelectionOpened] = useState(false);

    const [isValid, setIsValid] = useState(true);
    const [validationModel, setValidationModel] = useState<any>();
    const [isRequired, setIsRequired] = useState(false);

    const formValidationModel = useContext(ValidationContext) as any;
    const fieldValidationModel = formValidationModel?.fields?.[props.dataField!];

    useEffect(() => {
        if (fieldValidationModel) {
            setIsValid(fieldValidationModel?.isValid !== undefined ? fieldValidationModel.isValid : true);
            setValidationModel(fieldValidationModel);
        }
    }, [fieldValidationModel?.isValid]);

    useEffect(() => {
        const fieldValidationModel = formValidationModel?.fields?.[props.dataField!];
        if (fieldValidationModel) {
            setValidationModel(fieldValidationModel);
            setIsRequired(props.isRequired ?? fieldValidationModel?.isRequired);
        }
    }, []);

    let currentPath: any;

    const handleTreeSelectorCancellation = () => {
        setSelectionOpened(false);
    };

    const handleTreeSelectorProductGroupSelection = (productGroup: any) => {
        validateField(productGroup, validationModel);
        let payload = {
            group: productGroup,
            productId: null,
            productGroupPath: productGroup.productGroupPath,
            productPath: "",
        };
        props.onGroupSelectionChange(payload);
        setSelectionOpened(false);
    };

    const handleProductGroupSelectorOpen = (e: any) => {
        e.preventDefault();
        setSelectionOpened(true);
    }

    let emptyLabel = t('EmptyLabel');
    let selectedProductGroupName = t(`${props.selectedProductGroupId}.name`) ?? props.selectedProductGroupName;
    if (selectedProductGroupName === 'ProductGroupsTree.undefined.name') {
        selectedProductGroupName = emptyLabel;
    }

    let label;
    if (props.label) {
        label = t('Label') ?? props.label;
    }

    return (
        <>
            {selectionOpened && (
                <ProductTreeSelector
                    selectedGroup={{ id: props.selectedProductGroupId }}
                    selectedProductId={props.productId}
                    productGroups={props.productGroups}
                    handleCancellation={handleTreeSelectorCancellation}
                    handleGroupSelection={handleTreeSelectorProductGroupSelection}
                    handleProductSelection={() => { }}
                    selectionOfProductIsRequired={false}
                />
            )}
            <div className={isValid ? "row" : "row invalid"}>
                {label && (
                    <label htmlFor={props.id} className="col-sm-3 col-form-label zvlabel">
                        {label}{isRequired && <span className="required">*</span>}
                    </label>
                )}

                <div className="col-sm-9 link-primary cursor-help">
                    <a href="#" onClick={handleProductGroupSelectorOpen}>{selectedProductGroupName ?? emptyLabel}</a>
                </div>
            </div>
        </>
    );
}

export default ProductGroupSelector;